import type { ApiClient } from "./client";
import type { PromptSettings } from "./types";

/** Rogue's prompt, the parts admins edit: global (organizationId null) and per organization. */
export interface PromptsApi {
  get(organizationId: string | null): Promise<PromptSettings>;
  /** Per key: the new text, or null to inherit again. */
  update(organizationId: string | null, sections: Record<string, string | null>): Promise<PromptSettings>;
}

export function createHttpPromptsApi(client: ApiClient): PromptsApi {
  return {
    get: (organizationId) =>
      organizationId ? client.call("getOrganizationPromptSettings", { params: { id: organizationId } }) : client.call("getPromptSettings"),
    update: (organizationId, sections) =>
      organizationId
        ? client.call("updateOrganizationPromptSettings", { params: { id: organizationId }, body: { sections } })
        : client.call("updatePromptSettings", { body: { sections } }),
  };
}
